/**
 * 导出 CSV 文件。
 *
 * 带 BOM：不带的话 Excel（尤其是中文 Windows 版）会把 UTF-8 当成 ANSI 打开，
 * 中文与西语重音字母全变乱码 —— 而这两张表导出来十有八九是要发给别人的。
 *
 * `revokeObjectURL` 放在下一帧而不是紧接着 `click()`：Chrome 在点击与下载
 * 开始之间还有一小段异步，立刻 revoke 会让下载拿到一个空文件。
 * 这个 bug 只在"文件很小、下载瞬间开始"时偶发，靠肉眼很难复现。
 */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
